import React, { useEffect, useState, useContext } from 'react'
import { SwipeableDrawer } from '@mui/material'
import { DragHandle } from '@mui/icons-material'
import './M_DoubleTable.css'

import { useResizeHeight, M_Table, CrudParentChildTable, LoadingContext, NavigateContext } from '../../M_Components'

export function M_DoubleTable({ parentEntity, childEntity, rolePermissions, removeContextItems, viewName, field, hasConfirmation }) {
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { height, enableResize } = useResizeHeight(50, 300, 0)
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))

    const entity1 = childEntity !== undefined ? childEntity : 'accountOffice'
    const entity2 = parentEntity !== undefined ? parentEntity : 'account'

    const [openDrawer, setOpenDrawer] = useState(true)
    const [tableKey, setTableKey] = useState(Math.random())
    const [refresh, setRefresh] = useState(false)

    const tempFilterName = sessionStorage.getItem('filterName') ? sessionStorage.getItem('filterName') : ''
    const tempFilter = sessionStorage.getItem('filter') !== null ? new Map([[tempFilterName, sessionStorage.getItem('filter')]]) : new Map()
    const [filter, setFilter] = useState(tempFilter)
    const [filterName, setFilterName] = useState(tempFilterName)
    const [parentLine, setParentLine] = useState([])
    const [isCrud, setIsCrud] = useState(false)

    const [parentId, setParentId] = useState(JSON.stringify(JSON.parse(id) + ".1"))
    const [childId, setChildId] = useState(JSON.stringify(JSON.parse(id) + ".2"))

    const [FILTER, setFILTER] = useState(`${field} eq 00000000-0000-0000-0000-000000000000`)

    useEffect(() => {
        sessionStorage.removeItem('filterName')
        sessionStorage.removeItem('filter')
        getSessionStorageData(id)
        sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
    }, [])

    const sessionKeys = ['openDrawer', 'parentLine', 'filter', 'filterName', 'tableKey']

    useEffect(() => {
        if (refresh) {
            setRefresh(false)
        }
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
            setParentId(JSON.stringify(JSON.parse(newId) + ".1"))
            setChildId(JSON.stringify(JSON.parse(newId) + ".2"))
        }
    })

    const sessionStorageMachine = (id, key, value) => {
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        const tempOD = JSON.parse(sessionStorage.getItem(`${sessionID}openDrawer`))
        const tempPL = JSON.parse(sessionStorage.getItem(`${sessionID}parentLine`))
        const tempF = JSON.parse(sessionStorage.getItem(`${sessionID}filter`))
        const tempFN = JSON.parse(sessionStorage.getItem(`${sessionID}filterName`))
        const tempTK = JSON.parse(sessionStorage.getItem(`${sessionID}tableKey`))
        if (tempOD || tempPL || tempF || tempFN) {
            setParentLine(tempPL)
            return
        }

    }

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [openDrawer, parentLine, filter, filterName, tableKey])

    const resizeTableChild = (size) => {
        if (size < 0) size = -size
        let newSize = size
        const tempHead = document.body.getElementsByTagName('thead')[0]?.offsetHeight || 41
        const tempHeader = document.body.getElementsByClassName('header')[0]?.offsetHeight || 60
        const tempPaginator = document.body.getElementsByClassName('p-paginator')[0]?.offsetHeight || 60
        newSize = newSize - (tempHead + tempHeader + tempPaginator)

        return newSize
    }

    const resizeParentTable = (size) => {
        let newSize = size
        const tempTabs = document.body.getElementsByClassName('divTabs')[0]?.offsetHeight || 50
        const tempBody = document.body.offsetHeight === 0 ? window.screen.height - 80 : document.body.offsetHeight

        const tempHead = document.body.getElementsByTagName('thead')[0]?.offsetHeight || 41
        const tempHeader = document.body.getElementsByClassName('header')[0]?.offsetHeight || 60
        const tempPaginator = document.body.getElementsByClassName('p-paginator')[0]?.offsetHeight || 60
        newSize = ((tempBody - (tempTabs + tempHead + tempHeader + tempPaginator)) - newSize)

        return newSize
    }

    const openSecondTable = (e) => {
        if (e) {
            if (e.length < 1) {
                setFILTER(`${field} eq 00000000-0000-0000-0000-000000000000`)
                setOpenDrawer(true)
                setRefresh(true)
                return
            }
            else {
                setFilter(new Map([[viewName, `?page=1&pagesize=20&filter=${field} eq ${e[0].Id}`]]))
                setFilterName(viewName)
                setFILTER(`${field} eq ${e[0].Id}`)
                setOpenDrawer(true)
                setRefresh(true)
            }
        }
    }

    const openCrud = () => {
        //? parent child and field
        sessionStorage.setItem('hasConfirmation', hasConfirmation)
        sessionStorage.setItem('crudDoubleTable', JSON.stringify({ parent: entity2, child: entity1, field: field }))
        ctx2.newTab('go/createDoubleTable', `Create ${entity2}`)
    }

    return (
        <>
            {isCrud ?
                <>
                    <CrudParentChildTable
                        operation={'Create'}
                        open={isCrud}
                        setOpen={setIsCrud}
                        parent={entity2}
                        child={entity1}
                        field={field}
                        setRefresh={setRefresh}
                    />
                </>
                :
                <>

                    <div id='tableParent' style={{ position: 'absolute', top: document.body.getElementsByClassName('divTabs')[0]?.offsetHeight || '0px', width: '100%' }}>
                        <M_Table
                            entityName={entity2}
                            rolePermissions={rolePermissions}
                            useSessionStorage={true}
                            tableHeight={openDrawer ? resizeParentTable(height) : null}
                            manualId={parentId}
                            onPassLine={(e) => {
                                setTableKey(Math.random())
                                openSecondTable(e)
                            }}
                            removeContextItems={removeContextItems}
                            selectSingle={true}
                            isParentTable={true}
                            setParentLine={setParentLine}
                            replaceFunctions={new Map([['Create', () => openCrud()]])}
                        />
                    </div>

                    <SwipeableDrawer
                        id='drawer'
                        className='M_swipeableDrawerParent'
                        anchor={'bottom'}
                        open={openDrawer}
                        onClose={() => setOpenDrawer(false)}
                        onOpen={() => openSecondTable()}
                        // style={{ height: -height }}
                        PaperProps={{ style: { height: height } }}
                        variant="persistent"
                    >
                        <div id='dragger' className='M_draggerParent'>
                            <div className='M_divDraggerInteriorParent'>
                                <DragHandle className='M_dragHandleIconParent' onMouseDown={(e) => { enableResize(e) }} />
                            </div>
                        </div>
                        <div id='tableChild' className='M_divTableParent' key={openDrawer ? tableKey : '1'}>
                            <M_Table
                                entityName={entity1}
                                manualId={childId}
                                rolePermissions={rolePermissions}
                                useSessionStorage={true}
                                tableHeight={resizeTableChild(height)}
                                onPassLine={(e) => { }}
                                removeContextItems={removeContextItems}
                                refresh={refresh}
                                setRefresh={setRefresh}
                                isChildTable={true}
                                parentLine={parentLine}
                                field={field}
                                FILTER={FILTER}
                                selectSingle={true}
                            />
                        </div>
                    </SwipeableDrawer>
                </>}
        </>
    )
}